import { render, staticRenderFns } from "./4Summary.vue?vue&type=template&id=d8a47244&scoped=true"
import script from "./4Summary.vue?vue&type=script&lang=js"
export * from "./4Summary.vue?vue&type=script&lang=js"
import style0 from "./4Summary.vue?vue&type=style&index=0&id=d8a47244&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8a47244",
  null
  
)

export default component.exports